function scrollToItem(selector,offset) {
    $('html, body').animate({
        scrollTop: $(selector).offset().top + offset + "px"
    }, 1000);
}

(function($) {
    $(function() {

        // CUSTOM NUMBER INPUT CHANGES
        $('.js-scrollto').click(function(e){
            e.preventDefault();
            var id = $(this).attr('href');
            scrollToItem(id,-110);

            $('.sidebar .is-active').removeClass('is-active');
            $(this).addClass('is-active');
        });

    });
})(jQuery);
